/**
 *
 * RepeatMonthlyByPicker
 *
 */

import {
  BaseOptionsPicker,
  BaseOptionsPickerProps,
} from 'app/components/BasicPickers/BaseOptionsPicker';
import { RepeatMonthlyBy } from 'enums/RepetitiveOptions';
import { Entity } from 'types/common';
import { enumToEntityArray } from 'utils/enumKeys';

export interface RepeatMonthlyByPickerProps
  extends Omit<BaseOptionsPickerProps<Entity<number>>, 'getOptions'> {}

export const initRepeatMonthlyByData = (
  initval: number | string | undefined,
): Promise<Entity<number>[]> => {
  if (initval === undefined) {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([] as Entity<number>[]);
    });
  } else {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve(
        enumToEntityArray(RepeatMonthlyBy).filter(item => {
          return item.Id.toString() === initval;
        }),
      );
    });
  }
};
const getOptions = (searchTerm: string | null) => {
  let items = enumToEntityArray(RepeatMonthlyBy);

  if (searchTerm !== null && searchTerm !== '') {
    return items.filter(
      f => f.Name.startsWith(searchTerm) || f.Name.indexOf(searchTerm) !== -1,
    );
  }
  return items;
};
export function RepeatMonthlyByPicker(props: RepeatMonthlyByPickerProps) {
  return (
    <BaseOptionsPicker
      mini={props.mini ? true : undefined}
      size={props.size}
      getOptions={getOptions}
      value={props.value}
      id={props.id || 'RepeatMonthlyById'}
      style={{ marginRight: '4px' }}
      {...props}
    />
  );
}
